module.exports = __webpack_public_path__ + "static/media/mh.8f1f9134.svg";